import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-xs font-bold uppercase tracking-[0.2em] text-slate-400" }, "Forma de envio", -1)
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center py-6"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/LogoIcon.svg",
  class: "w-14 animate-loading-spin"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "grid grid-cols-1 gap-3 sm:grid-cols-2"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "mb-2 flex items-center justify-between gap-2" }
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = { class: "mt-2 font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    (_ctx.loading == 'loading')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.slice(1), (option) => {
            return (_openBlock(), _createElementBlock("button", {
              key: option.Codigo || option.Nome,
              type: "button",
              class: _normalizeClass(["rounded-xl border p-4 text-left transition", _ctx.selectedFreight == option.Codigo ? 'border-slate-950 bg-slate-950 text-white' : 'border-slate-200 bg-slate-50 text-slate-950 hover:border-slate-400']),
              onClick: ($event: any) => (_ctx.$emit('select', option))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("strong", _hoisted_9, _toDisplayString(option.Nome), 1),
                _createVNode(_component_Icon, {
                  icon: "solar:box-minimalistic-linear",
                  class: "text-sm"
                })
              ]),
              _createElementVNode("p", {
                class: _normalizeClass(["text-xs", _ctx.selectedFreight == option.Codigo ? 'text-slate-300' : 'text-slate-500'])
              }, _toDisplayString(Number(option.Prazo) > 0 ? `${option.Prazo} dias úteis` : ''), 3),
              _createElementVNode("p", _hoisted_10, _toDisplayString(Number(_ctx.normalizeValue(option.Valor)) > 0 ? _ctx.formatCurrency(_ctx.normalizeValue(option.Valor)) : 'Grátis'), 1)
            ], 10, _hoisted_7))
          }), 128))
        ]))
  ]))
}